export enum EStatusOficio
{
    EmDigitacao = 1,
    Autorizado = 2,
    Excluido = 3,
}
